<template>
  <admin-wrapper
    title-translation-path="admin.SCADA"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :is-custom-saving="isSaving"
    :is-form-fetched="isFormFetched"
    @save="saveCard"
  >
    <template #visualization.input>
      <predefined-styles class="mb-16" :layer-id="layerId" :data-source-name="dataSourceName"></predefined-styles>
    </template>
    <template #featureCard.input>
      <draggable-lists-manage-card
        :layer-id="layerId"
        @update:hasAnyRequiredOnRightSide="hasAnyRequiredOnRightSide = $event"
        :has-edit-attributes="true"
        right-title="admin.myAttributes"
      >
      </draggable-lists-manage-card>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DraggableListsManageCard from '@/components/DraggableListsManageCard';
import PredefinedStyles from '@/components/PredefinedStyles';

export default {
  name: 'ScadaSettings',
  components: {
    AdminWrapper,
    DraggableListsManageCard,
    PredefinedStyles,
  },
  data: () => ({
    hasAnyRequiredOnRightSide: false,
    isFormFetched: false,
    isSaving: false,
  }),
  computed: {
    currentLayerSchema: get('layers/currentLayerSchema'),
    dataSourceName: get('admin/modulesMapping@scada.datasource_name'),
    isModuleEnabled: get('admin/settingsValues@scada_module_enabled'),
    moduleEnabler() {
      return {
        name: 'scada_module_enabled',
        translationPath: 'admin.scadaModule',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.scadaModule') }),
      };
    },
    layerId: get('admin/modulesMapping@scada.layer_id'),
    inputs() {
      return [
        {
          name: 'visualization',
          disabled: !this.isModuleEnabled,
          subtitle: `admin.scadaVisualizationSubtitle`,
          translationPath: 'admin.visualizationOnMap',
          isCustom: true,
          align: 'start',
        },
        {
          name: 'featureCard',
          clearable: true,
          translationPath: 'admin.featureCard',
          isCustom: true,
          subtitle: this.$i18n.t('admin.setFeatureCard', { type: this.$i18n.t('admin.objectType') }),
          align: 'start',
        },
      ];
    },
  },
  methods: {
    editLayer: call('layers/editLayer'),
    getDataSourceForm: call('layers/getDataSourceForm'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    getLayerMetadata: call('layers/getLayerMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    async saveCard() {
      try {
        this.isSaving = true;
        await this.editLayer({
          layer_type: 'features_layers',
          layer_id: this.layerId,
          body: {
            form_schema: {
              elements: this.currentLayerSchema,
            },
          },
        });
        this.isSaving = false;
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successEditSetting'),
        });
      } catch {
        this.isSaving = false;
      }
    },
    async init() {
      await this.getModulesMapping();
      await Promise.all([
        this.getDataSourceForm(this.dataSourceName),
        this.getFeaturesLayer(this.layerId),
        this.getLayerMetadata({ dataSource: this.dataSourceName }),
      ]);
      this.isFormFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
